import React from "react";
import { InformationIcon, UserIcon } from "../../../../components/Icons";
import { StyledCenterDiv, StyledFlexDiv } from "../../../../styles/MainStyles";
import { StyledIconInfo } from "../../../../styles/pages/AcademicActivityPlan/ModalDetailsAcademicActivityStyles";
import {
    StyledTitle,
    StyledSubTitle,
} from "../../../../styles/pages/AdministratorTach/ModalInformation";

interface IHeaderInformation {
    name: string;
    matriculaAdp: string;
}

const HeaderInformation: React.FC<IHeaderInformation> = ({
    name,
    matriculaAdp,
}) => {
    return (
        <StyledCenterDiv style={{ flexDirection: "column", gap: 12 }}>
            <StyledTitle>Informações TACH</StyledTitle>
            <StyledFlexDiv>
                <StyledIconInfo>
                    <UserIcon />
                    <span>{`Professor(a) ${name}`}</span>
                </StyledIconInfo>
                <StyledIconInfo>
                    <InformationIcon />
                    <span>{`Matrícula: ${matriculaAdp}`}</span>
                </StyledIconInfo>
            </StyledFlexDiv>
            <StyledSubTitle>
                Confira abaixo a carga horária do professor selecionado
            </StyledSubTitle>
        </StyledCenterDiv>
    );
};

export default HeaderInformation;
